import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import Modal from '../../../../Components/Modal/Modal';
import PatientProfileEdit from './PatientProfileEdit';
import { User } from '../../../../graphql/graphql';

interface Props {
	isOpened: boolean;
	onClose: () => void;
	onSuccess: () => void;
	user: User;
	childId?: string;
}
const PatientProfileEditModal: React.FC<Props> = ({
	isOpened,
	onClose,
	onSuccess,
	user,
	childId,
}) => {
	return (
		<Modal opened={isOpened} onClose={onClose} size={Size.MD}>
			<Modal.Header
				title={
					childId
						? 'component.patientProfileEdit.editLegalRepresentative'
						: 'component.patientProfileEdit.modalTitle'
				}
				firstUpper
			/>
			<Modal.Content contentScroll={true}>
				<PatientProfileEdit
					user={user}
					onSuccess={onSuccess}
					childId={childId}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default PatientProfileEditModal;
